import {useEffect, useState} from "react";
import ValuerAmendFilePreview from "./ValuerAmendFilePreview";
import MimeTypes from "../../models/MimeTypes";
import ImageUtils from "../../utils/ImageUtils";
import cloud from "../../assets/upload_cloud.png";
import valuer_api from "../../api/valuer";


const ValuerAmendFileInput = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.sectionName
    const identifier = props.identifier

    // Required
    const field = props.field
    const inputActive = props.input
    const deleteActive = props.delete
    const fileCount = props.fileCount

    // Optional
    const requiredFiles = props.requiredFiles ? props.requiredFiles : 1
    const notes = props.notes
    const rowId = props.rowId ? props.rowId : false

    // Value
    const [newFileName, setNewFileName] = useState('')
    const [newFileBase64, setNewFileBase64] = useState('')

    const [files, setFiles] = useState([]);

    // File Preview Size
    const fileWidth = props.fileWidth
    const fileHeight = props.fileHeight

    // Saving Tracker
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (!summaryId || !section || !identifier) return
        GetFiles()
    }, [summaryId, section, identifier]);

    const GetFiles = () => {
        let response = valuer_api.ValuerAmendFileGet(summaryId, section, identifier);
        response.then(
            response => {
                let _fi = response.data.files
                for (let i = 0; i < _fi.length; i++) {
                    let file_type = _fi[i]["filename"].split(".").at(-1)
                    let FILE_DATA = _fi[i]["file_data"]
                    let MIME_TYPE = MimeTypes[file_type]
                    _fi[i]["base64"] = "data:" + MIME_TYPE + ";base64," + FILE_DATA

                    _fi[i].row = String(_fi[i].row ?? _fi[i].file_row ?? _fi[i].id ?? "NO_ROW");
                }
                setFiles(_fi)
            }
        ).catch((err) => {
            setErrorTitle("Failed to Get Files")
            setErrorMessage("The request to get the requests files has failed")
        })
    }

    const AddNewFile = (file_list) => {
        let updateTime = Date.now()
        AddToQueue(section, identifier, updateTime)
        let body = {
            "files": file_list
        }
        let response = valuer_api.ValuerAmendFilePut(summaryId, section, identifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, identifier, updateTime)
                setFiles(file_list)
            }
        ).catch((err) => {
            AddToErroredSaves(section, identifier, updateTime)
            setErrorTitle("Failed to Save Files")
            setErrorMessage("The request to save the files has failed")
        })
    }

    const deleteFile = (file_index) => {
        let updateTime = Date.now()
        AddToQueue(section, identifier, updateTime)
        let file_list = [...files]
        file_list.splice(file_index, 1);
        let body = {
            "files": file_list
        }
        let response = valuer_api.ValuerAmendFilePut(summaryId, section, identifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, identifier, updateTime)
                setFiles(f => {
                    let f_copy = [...f]
                    f_copy.splice(file_index, 1);
                    return f_copy
                })
            }
        ).catch((err) => {
            AddToErroredSaves(section, identifier, updateTime)
            setErrorTitle("Failed to Delete File")
            setErrorMessage("The request to delete the file has failed")
        })
    }


    const handlePaste = async (event) => {
        try {
            if (!navigator.clipboard) {
                // Clipboard API is restricted to HTTPS websites
                setErrorTitle("Clipboard Error")
                setErrorMessage("The Clipboard API is unavailable")
                return;
            }
            const clipboardItems = await navigator.clipboard.read();
            // Iterate over clipboard items until you find the first image file
            for (let clipboardItem of clipboardItems) {
                let imageTypes = clipboardItem.types.find(type => type.startsWith('image/'));
                if (!imageTypes) continue;
                const blob = await clipboardItem.getType(imageTypes);

                // Generate a file name and format
                let ts = Date.now()
                let fileEnding
                for (const [key, value] of Object.entries(MimeTypes))
                    if (value === imageTypes) fileEnding = "." + key
                if (!fileEnding) {
                    setErrorTitle("File Error")
                    setErrorMessage("The given file type is not supported")
                    break;
                }
                let filename = "paste_" + ts + fileEnding
                setNewFileName(filename)

                // Get Base64 From BLOB
                let base64_image = await ImageUtils.convertBase64(blob);
                setNewFileBase64(base64_image)

                // Only check the first image file
                break;
            }
        } catch (err) {
            setErrorTitle("File Error")
            setErrorMessage("There was an error reading the image from your clipboard")
        }
    };


    /*
    TODO: This was used during local testing - might need to be commented back in for further local testing
    const handlePaste = async (event) => {

        try {
            // Fallback clipboard access from event (works locally)
            const items = event.clipboardData?.items;
            if (!items) {
                return;
            }

            for (let i = 0; i < items.length; i++) {
                const item = items[i];

                if (item.kind === "file" && item.type.startsWith("image/")) {
                    const blob = item.getAsFile();

                    let ts = Date.now();
                    let fileEnding = "." + item.type.split("/")[1]; // crude fallback
                    let filename = "paste_" + ts + fileEnding
                    setNewFileName(filename)

                    let base64_image = await ImageUtils.convertBase64(blob);
                    setNewFileBase64(base64_image);

                    break;
                }
            }
        } catch (err) {
            console.error("Caught error:", err);
            setErrorTitle("File Error");
            setErrorMessage("There was an error reading the image from your clipboard");
        }
    };

     */
    const handleFileUploaderClick = () => {
        let element = document.getElementById("file-uploader-" + identifier)
        if (!element) return;
        element.click()
    }

    const handleDrop = async (ev) => {
        ev.preventDefault()
        let _files = ev.dataTransfer.files
        let _temp_files = [...files]
        for (let i=0; i<_files.length; i++) {
            let _file = _files[i]
            let base64 = await ImageUtils.convertBase64(_file);
            let _file_object = { filename: _file.name, base64: base64}
            if (rowId) {
                _file_object["row"] = rowId
            } else {
                _file_object["row"] = String(Date.now()) // unique row for each new file
            }
            _temp_files.push(_file_object)
        }
        AddNewFile(_temp_files)
    }

    const handleSelect = async (ev) => {
        let _temp_files = [...files]
        for (let i=0; i < ev.target.files.length; i++) {
            let file = ev.target.files[i]
            let base64 = await ImageUtils.convertBase64(file);
            let _file_object = {filename: file.name, base64: base64}
            if (rowId) {
                _file_object["row"] = rowId
            } else {
                _file_object["row"] = String(Date.now()) // unique row for each new file
            }
            _temp_files.push(_file_object)
        }
        AddNewFile(_temp_files)
    }

    const handleUploadClipboard = async (ev) => {
        if (!newFileName || !newFileBase64) return;
        let _temp_files = [...files]
        let _file_object = {
            "filename": newFileName,
            "base64": newFileBase64,
        }
        if (rowId) {
            _file_object["row"] = rowId
        } else {
            _file_object["row"] = String(Date.now()) // unique row for each new file
        }
        _temp_files.push(_file_object)
        AddNewFile(_temp_files)
    }

    const get_placeholders_map = () => {
        let placeholders = requiredFiles;
        if (files) placeholders = requiredFiles - files.length
        if (placeholders < 1) return []
        return new Array(placeholders).fill(true)
    }


    return (
        <div className="valuer-amend-file-field-container">
            {field && field
                ? <div className="valuer-amend-field-label"> {field} </div>
                : null
            }
            <div className="valuer-amend-file-list-preview-container">
                {files && files.map((file, idx) => {
                    return (
                        <ValuerAmendFilePreview filename={file.filename}
                                                file_base64={file.base64}
                                                fileWidth={fileWidth}
                                                fileHeight={fileHeight}
                                                setErrorMessage={setErrorMessage}
                                                setErrorTitle={setErrorTitle}
                                                deleteActive={deleteActive}
                                                deleteFunction={deleteFile.bind(this)}
                                                fileIndex={idx}
                        />
                    )
                })}
                {get_placeholders_map().map((file, idx) => {
                        return (
                            <ValuerAmendFilePreview fileWidth={fileWidth}
                                                    fileHeight={fileHeight}
                                                    deleteActive={deleteActive}
                                                    setErrorMessage={setErrorMessage}
                                                    setErrorTitle={setErrorTitle}/>
                        )
                })}
            </div>
            {inputActive && inputActive
                ?
                <div className={"valuer-amend-file-upload-fields-container " + (files && fileCount && files.length >= fileCount ? ' disabled' : '')}>
                    <div className="valuer-amend-file-upload-paste-container">
                        <textarea placeholder={"paste screenshot here"} className="valuer-amend-field image-paste"
                                  onPaste={handlePaste} value={newFileName} />
                        <div className="valuer-amend-fil-upload-paste-button link" onClick={() => handleUploadClipboard()}>
                            >
                        </div>
                    </div>
                    <div className="valuer-amend-file-upload-separator-text"> or </div>
                    <div className="valuer-amend-file-upload-drag-container">
                        <div className="valuer-amend-file-upload-valuer-dropzone" onDragOver={(ev) => ev.preventDefault()}
                             onDrop={handleDrop}>
                            <img src={cloud} className="valuer-amend-file-upload-valuer-dropzone-cloud" alt="upload cloud"/>
                            <div className="valuer-amend-file-upload-valuer-dropzone-text">
                                Drag and drop files here or <a className="valuer-amend-file-uploader-opener link"
                                                               onClick={() => handleFileUploaderClick()}> select a file</a>
                            </div>
                            <input type='file' id={"file-uploader-"+identifier} multiple={true} className="file-uploader-hidden" onChange={handleSelect}/>
                        </div>
                    </div>
                </div>
                :
                null
            }
            <div className="file-amend-file-upload-notes-container">
                {notes && notes.map((note) => {
                    return <div className="file-amend-file-upload-note" dangerouslySetInnerHTML={{__html: note}}/>
                })}
            </div>


        </div>
    )
}

export default ValuerAmendFileInput